import { render, staticRenderFns } from "./LandingRecentQueriesWidget.vue?vue&type=template&id=58d6d985&"
import script from "./LandingRecentQueriesWidget.vue?vue&type=script&lang=js&"
export * from "./LandingRecentQueriesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports